import React from 'react'

const AdminHome = () => {
  return (
    <div>
      <p></p>
    </div>
  )
}

export default AdminHome
